import { useMemo } from 'react';
import { useQuery, gql } from '@apollo/client';
import { FetchStatuses } from '../../types/FetchStatus';
export const ObjectTypeDefinitionsQuery = ("__gql__", "{\"kind\":\"Document\",\"definitions\":[{\"kind\":\"OperationDefinition\",\"operation\":\"query\",\"name\":{\"kind\":\"Name\",\"value\":\"ObjectTypeDefinitions\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"allObjectTypes\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"id\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"name\"}}]}}]}}]}", {
  id: null,
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "query",
    name: {
      kind: "Name",
      value: "ObjectTypeDefinitions"
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "allObjectTypes"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "id"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "name"
            }
          }]
        }
      }]
    }
  }]
});
const getObjectTypeNamesToIds = objectTypeDefinitions => {
  return objectTypeDefinitions.allObjectTypes.reduce((objectTypes, typeDef) => objectTypes.set(typeDef.name, typeDef.id), new Map());
};
export const useFetchObjectTypeNamesToIds = () => {
  const {
    data,
    loading,
    error
  } = useQuery(ObjectTypeDefinitionsQuery);
  const formattedResult = useMemo(() => {
    if (loading) {
      return {
        status: FetchStatuses.LOADING,
        data: null
      };
    }
    if (error) {
      return {
        status: FetchStatuses.REJECTED,
        data: null,
        error
      };
    }
    if (data) {
      return {
        status: FetchStatuses.RESOLVED,
        data: getObjectTypeNamesToIds(data)
      };
    }
    return {
      status: FetchStatuses.IDLE,
      data: null
    };
  }, [data, loading, error]);
  return formattedResult;
};